module.exports = __webpack_public_path__ + "static/img/default.c93f8d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/default.png
// module id = Lg5A
// module chunks = 184